import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 100%;
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;
export const Title = styled.span`
  font-size: 1.1em;
  font-weight: bold;

  ${(props) =>
    props.type === 'success' &&
    css`
      color: #07bc0c;
    `}
  ${(props) =>
    props.type === 'info' &&
    css`
      color: #3498db;
    `}
${(props) =>
    props.type === 'warning' &&
    css`
      color: #f1c40f;
    `}
${(props) =>
    props.type === 'error' &&
    css`
      color: #e74c3c;
    `}
`;
export const Content = styled.p`
  margin-top: 15px;
  font-size: 0.9em;
`;
